export default "__VITE_ASSET__BeZGqeCz__"